import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import useHttp from "../../../hooks/use-http";
import { endPoints } from "../../../config/end-points";
import { personalizeAction } from "../../../store/pesonalize-store";
import { campaignAction } from "../../../store/campaign-store";
import { cuteToast } from "../../UI/cute";
import UploadThumbnailModal from "./UploadThumbnailModal";

const ThumbnailModal = () => {

  const campaign_data = useSelector((state) => state.campaign.campaign_data);
  const { camp_id } = useParams();

  const dispatch = useDispatch(); 

  const [activePoster,setActivePoster] = useState(campaign_data.default_poster);

  const { sendRequest: updateDataRequest } = useHttp();

  const handleClick = (e,url) =>{
    e.preventDefault();

    updateDataRequest({
      url: endPoints.updateCampaign,
      method: "POST",
      body: {
        id:camp_id,
        default_poster:url
      },
    }, (response) => {
        // console.log(response)
        if (response.status === 200) {
          setActivePoster(url)

          dispatch(
            campaignAction.setCampaignData({
              campaign_data: {...campaign_data,default_poster:url},
            })
          );

          cuteToast({
            type: "success",
            message: "Changed successfully.",
            timer: 5000,
            title: "Thumbnail",
          });

        }else{
          cuteToast({
            type: "error",
            message: response.message,
            timer: 3000,
            title: "",
          });
        }
    })
  }
  // console.log(activePoster)

  return (
    <>
      <div className="modal popup2" id="thumnail">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Thumbnail</h4>
              <button
                type="button"
                className="btn_close2"
                data-bs-dismiss="modal"
                onClick={(e)=>dispatch(personalizeAction.setPersonalizeThumbnailModal({personalize_thumbnailmodal:false}))}
              >
                <i className="fa fa-close"></i>
              </button>
            </div>

            <div className="modal-body">
              <div className="p-4">
                <div className="frame_bx activePoster">
                  <figure>
                    {(activePoster) && (
                      <img
                        src={activePoster}
                        className="img-fluid"
                        alt="Thumbnail img"
                      />
                    )}
                  </figure>
                  <h4 className="m-0">
                    Use default, Gif or upload images
                    for the thumbnail.{" "}
                  </h4>
                </div>
              </div>

              <div className="p-3 ps-2 pe-2 pt-0">
                <div className="row">
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6 col-6">
                        <div className="frame_small_col">
                          <p className="smallfont m-0">Default frame</p>
                          <a
                            href="#0"
                            className="fr_md d-flex align-items-center justify-content-center"
                            onClick={(e)=>{handleClick(e,campaign_data.poster)}}
                          >
                            <span className={`select_img ${activePoster === campaign_data.poster ? '':'d-none'}`}>
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/check1.png"
                                }
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src={campaign_data.poster}
                                className="img-fluid"
                                alt="img"
                                // style={{height: "90px",objectFit: "cover"}}
                              />
                            </figure>
                          </a>
                        </div>
                      </div>

                      <div className="col-md-6 col-6">
                        <div className="frame_small_col">
                          <p className="smallfont m-0">GIF preview</p>
                          <a
                            href="#0"
                            className="fr_md d-flex align-items-center justify-content-center"
                            onClick={(e)=>{handleClick(e,campaign_data.gif_url)}}
                          >
                            <span className={`select_img ${activePoster === campaign_data.gif_url ? '':'d-none'}`}>
                              <img
                                src={
                                  process.env.PUBLIC_URL +
                                  "/assets/images/check1.png"
                                }
                                className="img-fluid"
                                alt="img"
                              />
                            </span>
                            <figure className="m-0">
                              <img
                                src={campaign_data.gif_url}
                                className="img-fluid"
                                alt="img"
                              />
                            </figure>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <p className="smallfont m-0">Upload a new frame</p>
                    <div className="row">
                      <div className="col-md-6 col-6">
                        <div className="frame_small_col upload_frame_bx">
                            {campaign_data.upload_thumb ? (
                              <a
                              href="#0"
                              className="fr_md d-flex align-items-center justify-content-center"
                              onClick={(e)=>{handleClick(e,campaign_data.upload_thumb)}}
                              >
                                <span className={`select_img ${activePoster === campaign_data.upload_thumb ? '':'d-none'}`}>
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/check1.png"
                                    }
                                    className="img-fluid"
                                    alt="img"
                                  />
                                </span>
                                <figure className="m-0">
                                  <img
                                    src={campaign_data.upload_thumb}
                                    className="img-fluid"
                                    alt="img"
                                  />
                                </figure>
                              </a>
                            ) : (
                              <a
                                className={`${campaign_data.upload_thumb ? '': 'fr_md' } d-flex align-items-center justify-content-center text-center text-decoration-none`}
                                href="#importimage" 
                                data-bs-toggle="modal"
                              >
                                <h4 className="m-0">
                                  <i className="mb-1 d-inline-block">
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/add2.png"
                                      }
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </i>
                                  <br />
                                  UPLOAD
                                </h4>
                              </a>
                            )}
                            
                          
                          {campaign_data.upload_thumb && (
                            <a
                              className="d-flex align-items-center justify-content-center text-center text-decoration-none"
                              href="#importimage" data-bs-toggle="modal"
                            >
                              <h6 className="b_txt m-0 pt-1">Upload Frame</h6>
                            </a>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6 col-6 d-none">
                        <div className="frame_small_col select_ff_video">
                          <a
                            href="#0"
                            className="fr_md d-flex align-items-center justify-content-center text-center text-decoration-none"
                          >
                            <p className="m-0 p-1">
                              Select a frame <br />
                              from the video
                            </p>
                          </a>
                          <h6 className="b_txt m-0 pt-1">Choose Frame</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>

                <div className="setgif pt-5 d-none">
                  <div className="form-check m-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="defaultCheck1"
                    />
                    <label className="form-check-label" htmlFor="defaultCheck1">
                      Set GIF as default for all new videos{" "}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UploadThumbnailModal setActivePoster={setActivePoster}/>
    </>
  );
};

export default ThumbnailModal;
